import React, { Component } from "react";
import Table from "../../../components/table/Table";
import { Navigate } from "react-router-dom";
import moment from "moment";
import SwalServices from "../../../services/swalServices/SwalServices";
import ActionContainer from "../../../components/UIComponent/ActionTableComponent/actionContainer";
import DropdownAction from "../../../components/dropdown/DropdownAction";
import MembershipTaskListServices from "../../../services/axiosServices/apiServices/MembershipTaskListServices";
import DropdownSelect from "../../../components/dropdown/Dropdown";
import MTOTaskListProcess from "./MTOTaskListProcess";
import CorporateMemberServices from "../../../services/axiosServices/apiServices/CorporateMemberServices";
import { saveAs } from "file-saver";

import {
  CommonValidationMessages,
  CommonSuccessMessages,
  SuccessMessage,
} from "../../../utils/Messages";
import {
  isValidForm,
  validate,
} from "../../../utils/validation/CommonValidator";
// import SendForApprove from "./SendApproveModal";
import SendPaymentLink from "../membershipTaskList/SendPaymentLink";
// import SendQuotation from "./SendQuotation";
// import SendInvoice from "./SendInvoice";
// import EscalateModal from "./EscalateModal";
// import SendClarifications from "./SendClarifications";
import {
  yearDifference,
  //, monthDifference
} from "../../../utils/DateUtils";
import { encryptAES } from "../../../utils/Encryption";
import Selector from "../../../components/dropdown/commonDropdown/Selector";
import IndividualMemberService from "../../../services/axiosServices/apiServices/IndividualMemberService";
import FinanceServices from "../../../services/axiosServices/apiServices/FinanceServices";
import MTOServices from "../../../services/axiosServices/apiServices/MTOServices";
import SendClarifications from '../membershipTaskList/SendClarifications'
import { convertToDecimal } from "../../../utils/Utils";

export default class MTOTaskList extends Component {
  constructor(props) {
    super(props);
    this.TaskListServices = new MembershipTaskListServices();
    this.corporateMemberServices = new CorporateMemberServices();
    this.individualMemberServices = new IndividualMemberService();
    this.mtoServices = new MTOServices();
    this.financeService = new FinanceServices();
    this.swalServices = new SwalServices();
    this.state = {
      isValidStartUpMember: true,
      pagination: {
        pageNo: 1,
        pageSize: 10,
        orderByColumn: "",
        orderFlag: 0,
        searchText: "",
        status: 0,
        dateFrom: "",
        dateTo: "",
        filterByStatus: "",
      },
      mtoPricing: {
        ordinaryMtoPricingId: 0,
        qualifyingMtoPricingId: 0,
        ordinaryMtoTier: '',
        qualifyingMtoTier: '',
        ordinaryMembershipTypeId: 0,
        qualifyingMembershipTypeId: 0,
        ordinarySubscriptionPrice: 0,
        qualifyingSubscriptionPrice: 0,
        mtoPricingData: [],
      },
      ceoDetails: {
        bussinessMobile: 0,
        contactRoleId: 0,
        createdAppId: null,
        createdBy: null,
        designation: '',
        emailAddress: '',
        emailSubscriptionId: '',
        experienceYears: '',
        firstName: '',
        lastName: '',
        memberId: 0,
        mrMrsId: 0,
        officeDID: '',
        sameAsFirstFlag: false,
        yearsId: 0,
      },
      firstRepresentativeDetails: {
        bussinessMobile: 0,
        contactRoleId: 0,
        createdAppId: null,
        createdBy: null,
        designation: '',
        emailAddress: '',
        emailSubscriptionId: '',
        experienceYears: '',
        firstName: '',
        lastName: '',
        memberId: 0,
        mrMrsId: 0,
        officeDID: '',
        sameAsFirstFlag: false,
        yearsId: 0,
      },
      totalResultes: "",
      taskList: [],
      isLoading: false,
      isLoadingPayment: false,
      isLoadingReject: false,
      isLoadingApprove: false,
      isLoadingClarification: false,
      isLoadingSendMail1: false,
      isLoadingSendMail2: false,
      route: null,
      redirect: null,
      clarification: '',
      //Dropdown Arrays Start
      membershipType: [],
      membershipRevenue: [],
      serviceType: [],
      industriesServed: [],
      associationBenefits: [],
      getToKnow: [],
      servicesTypeData: [],
      industriesServedData: [],
      billingCategories: [],
      associationBenefitsData: [],
      transactionTypes: [],
      //Dropdown Arrays End
      statusList: [
        {
          value: 2,
          label: "Submitted",
        },
        {
          value: 3,
          label: "Sent For Clarification",
        },
        {
          value: 6,
          label: "Sent For Payment",
        },
        {
          value: 7,
          label: "Approved",
        },
      ],
      taskDetails: {
        taskId: 0,
        memberId: 0,
        contactRoleId: 0,
        billingCategoryId: 0,
        subscriptionStartDate: null,
        subscriptionEndDate: null,
        membershipTaskStatusId: 0,
        transactionTypeId: 0,
        approvalDate: null,
        isEndorsed: false,
        isCouncilApproved: false,

        membershipTypeId: 0,
        organisationName: "",
        organisationUEN: "",
        incorporationDate: null,
        paidUpCapital: 0,
        servicesTypeId: 0,
        industriesServedId: 0,
        associationBenefitsId: 0,
        generalEmailAddress: "",
        generalBusinessTelephone: null,
        statusId: 0,
        endorsersId1: 0,
        endorsersId2: 0,
        representativeId1: 0,
        representativeId2: 0,
        isRejected: 0,
        designation: '',
        firstName: '',
        lastName: '',
        entranceFee: 0,
        annualFee: 0,
        includedChapter: 0,
        additionalChapterPrice: 0,
        subtotalPrice: 0,
        gstPrice: 0,
        discountedPrice: 0,
        totalPrice: 0,
        paymentsCreditsApplied: 0,
        netTotal: 0,
        membersReceiptId: 0,
        subscriptionFee: 0,
        membershipPaymentTypeId: 0,
        transactionId: "",
        voucherCode: "",
        membershipPaymentInvoicePath: '',
        endorsementSatusForEndorser1: 0,
        endorsementSatusForEndorser2: 0,

        //mtoregistryData
        mtoRegistryId: 0,
        membershipTypeId: 0,
        insuranceCompanyName: '',
        policyNumber: '',
        expiryDate: null,
        insurancePolicyFilePath: '',
        mtoSubscriptionStartDate: null,
        mtoSubscriptionEndDate: null,
        mtoCertificateNo: '',
        mtoCertificateFilePath: '',
        mtoRegistryFee: 0,
        mtoGSTAmount: 0,
        mtoTotalAmount: 0,
      },
      gstRate: 0,
      gstAmount: 0,
      gstPercentage: 0,
      setSendClarifications: false,
      setDropdownOpen: false,
      membershipTaskListProcessModal: false,
      setAddeditModalOpen: false,
      setPaymentLink: false,
      sendQuotation: false,
      sendInvoice: false,
      sendEscalation: false,
      sendReject: false,
      basePriceTable: [],
      allowableDiscountTable: [],
      percentageDiscountTable: [],
      systemCalculatedTable: [],
      disablePaymentButton: false,
      disableSubscription: true,
      sendEscalate: {
        memberId: 0,
        firstName: "",
        lastName: "",
        organisationName: "",
        organisationUEN: "",
        generalEmailAddress: "",
        generalBusinessTelephone: 0,
        internalNotes: "",
      },
      validationRule: {
        membershipTypeId: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Membership Type'),
          },
        ],

        //Organisation Profile Validation Rules
        organisationName: [
          {
            type: 'require',
            message: CommonValidationMessages.FieldRequired.replace('{0}', 'Organisation Name'),
          },
        ],
        organisationUEN: [
          {
            type: 'require',
            message: CommonValidationMessages.FieldRequired.replace('{0}', 'Organisation UEN'),
          },
        ],
        incorporationDate: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Incorporation Date'),
          },
        ],
        subscriptionStartDate: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Commencement Date'),
          },
        ],
        subscriptionEndDate: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Commencement Date'),
          },
        ],
        paidUpCapital: [
          {
            type: 'require',
            message: CommonValidationMessages.FieldRequired.replace('{0}', 'Paid Up Capital'),
          },
        ],
        // mailingCountryId: [
        //   {
        //     type: 'require',
        //     message: Messages.CommonValidationMessages.SelectRequired.replace('{0}', 'Country of Mailing Address'),
        //   },
        // ],

        //Other Information Validation Rules
        servicesTypeData: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Types of Services Your Organisation Offers'),
          },
        ],
        industriesServedData: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Types of Industries Your Organisation Serves'),
          },
        ],
        associationBenefitsId: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Your Organisation Benefits from Joining The Association'),
          },
        ],

        //Endorsers
        endorsersId1: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Original Member Endorser'),
          },
        ],
        endorsersId2: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Endorser Company'),
          },
        ],
        representativeId1: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Representative'),
          },
        ],
        representativeId2: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Representative'),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
      actionDropdown: ["Process", "Delete"],
    };
    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    this.getAllDropdownsForTaskList();
  }

  handleChangeMultiDropdown(selected, identity) {
    if (identity === "ServicesType") {
      const maxSelections = 3;
      const limitedSelections = selected.slice(0, maxSelections);
      this.setState({
        servicesTypeData: limitedSelections
      });
    } else if (identity === "IndustriesServed") {
      const maxSelections = 3;
      const limitedSelections = selected.slice(0, maxSelections);
      this.setState({
        industriesServedData: limitedSelections
      });
    }
    else if (identity === "AssociationBenefits") {
      const maxSelections = 3;
      const limitedSelections = selected.slice(0, maxSelections);
      this.setState({
        associationBenefitsData: limitedSelections
      });
    }
  }

  getInvoiceReceiptPdfByBookingId = (bookingId, type) => {
    let reqParams = [bookingId, type];
    this.individualMemberServices.getInvoiceReceiptPdfByBookingId(reqParams).then((response) => {
      if (response != null) {
        var file = new Blob([response.data], { type: "application/pdf" });
        var filename = this.state.taskDetails.insurancePolicyFilePath;
        // const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        //  const pdfWindow = window.open();
        //  pdfWindow.location.href = fileURL;   
        saveAs(file, filename);
      } else {
        this.swalServices.Error(response.message);
      }
    });
  };

  getAllMTOTasksList = (pagination = this.state.pagination) => {
    this.setState({ isLoading: true });
    this.mtoServices.getAllMTOTasksList(pagination).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let details = response.responseItem.responseContent.itemList;
        details.map((key, index) => {
          key.registrationDate = moment(key.registrationDate).format(
            "DD MMM YYYY"
          );
          if (key.generalEmailAddress === null || key.generalEmailAddress === "") {
            key.generalEmailAddress = "-";
          }
          if (key.organisationName === null || key.organisationName === "") {
            key.organisationName = "-";
          }
          if (key.organisationUEN === null || key.organisationUEN === "") {
            key.organisationUEN = "-";
          }
          if (key.registrationDate === null || key.registrationDate === "") {
            key.registrationDate = "-";
          }
          return key;
        });
        this.setState({ taskList: details });
        this.setState({
          totalResultes: response.responseItem.responseContent.totalCount,
        });
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
    });
  };

  getAllDropdownsForTaskList = () => {
    this.TaskListServices.getAllDropdownsForTaskList().then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let membershipType = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "MembershipType");

        let membershipRevenue = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "MembershipRevenue");

        let countries = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "Countries");

        let serviceType = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "ServicesType");
        serviceType = serviceType.map((p) => ({
          value: p.id,
          label: p.name,
        }));

        let associationBenefits = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "AssociationBenefits");
        associationBenefits = associationBenefits.map((p) => ({
          value: p.id,
          label: p.name,
        }));

        let industriesServed = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "IndustriesServed");
        industriesServed = industriesServed.map((p) => ({
          value: p.id,
          label: p.name,
        }));

        let getToKnow = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "CorporateGetToKnowUs");

        // let associationBenefits = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "AssociationBenefits");

        let mrMrs = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "MrMrs");

        let designation = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "Designation");

        let years = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "Years");

        let emailCirculars = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "EmailSubscription");

        let billingCategories = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "BillingCategory");

        let transactionTypes = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "TransactionType");
        // membershipArr.map(function (item) {
        //   delete item["dropdownName"];
        //   return item;
        // });
        // transactionArr.map(function (item) {
        //   delete item["dropdownName"]; return item;
        // });
        // billingCategoryArr.map(function (item) {
        //   delete item["dropdownName"]; return item;
        // });
        // membershipRevenueArr.map(function (item) {
        //   delete item["dropdownName"]; return item;
        // });
        // sourceArr.map(function (item) {
        //   delete item["dropdownName"]; return item;
        // });
        // userArr.map(function (item) {
        //   delete item["dropdownName"]; return item;
        // });
        this.setState(
          {
            membershipType: membershipType,
            membershipRevenue: membershipRevenue,
            countries: countries,
            serviceType: serviceType,
            industriesServed: industriesServed,
            getToKnow: getToKnow,
            associationBenefits: associationBenefits,
            mrMrs: mrMrs,
            designation: designation,
            years: years,
            emailCirculars: emailCirculars,
            billingCategories: billingCategories,
            transactionTypes: transactionTypes,
          },
          () => this.getAllMTOTasksList()
        );
      } else {
        this.swalServices.Error(response.message);
        this.getAllMTOTasksList();
      }
      this.setState({ isLoading: false });
    });
  };

  generatePaymentInvoice = () => {
    let request = { ...this.state.taskDetails }
    this.corporateMemberServices.generatePaymentInvoice(request).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let taskDetails = response.responseItem.responseContent;

        // Merge new values with existing taskDetails
        // let taskDetails = {
        //   ...this.state.taskDetails,
        //   membershipPaymentInvoicePath: details.membershipPaymentInvoicePath
        // };
        // Update taskDetails in state
        this.setState({ taskDetails: taskDetails }, () => {
          this.addMembershipPaymentData();
        });
        window.location.reload();
      }
      else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
    })
  }

  refreshTable = () => {
    // Fetch data again or perform any action to refresh the table
  }

  rejectApplicationForMember = () => {
    let id = this.state.taskDetails.memberId;
    let TaskId = this.state.taskDetails.taskId;
    if (id > 0 && id != null) {
      let detail = this.state.taskDetails;

      detail.isRejected = true;
      let isRejected = true;
      this.setState({ taskDetails: detail })

      let request = { ...this.state.taskDetails }
      request.id = this.state.taskDetails.memberId;
      request.isRejected = isRejected
      request.taskId = this.state.taskDetails.taskId;
      request.isMTO = true

      // let request = [id, isRejected, TaskId]
      this.setState({ isLoadingReject: true });

      this.TaskListServices.rejectApplicationForMember(request).then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          this.setState({ sendReject: true }, () =>
            this.setState({ setAddeditModalOpen: false })
          );
          window.location.reload();
        }
        else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoadingReject: true });
      })
    }
  }

  getTaskByCompanyId = (companyId) => {
    this.TaskListServices.getTaskByCompanyId(companyId).then((response) => {
      let desiredId = response.responseItem.responseContent.membershipTypeId;
      let foundIndex = this.state.membershipType.find(
        (item) => item.id === desiredId
      ) ? this.state.membershipType.find(
        (item) => item.id === desiredId
      ).id : undefined;

      if (desiredId === foundIndex) {
        if (response.statusCode === 200 && response.responseItem != null) {
          response.responseItem.responseContent.transactionTypeId = response.responseItem.responseContent.transactionTypeId === null ? 1 : response.responseItem.responseContent.transactionTypeId;
          response.responseItem.responseContent.approvalDate = response.responseItem.responseContent.approvalDate === null ? moment(new Date()).format("YYYY-MM-DD") : response.responseItem.responseContent.approvalDate;
          this.setState(
            { taskDetails: response.responseItem.responseContent },
            () => {
              let data = { ...this.state.taskDetails };
              if (this.state.taskDetails.industriesServedId && this.state.taskDetails.industriesServedId !== 0 && this.state.taskDetails.industriesServedId !== "0") {
                var array = (this.state.taskDetails.industriesServedId !== null || this.state.taskDetails.industriesServedId !== "") ? this.state.taskDetails.industriesServedId.split(',') : [];
                let industriesServedArray = this.state.industriesServedData;
                const filteredArray = array.filter(value => value !== "0");
                if (filteredArray && filteredArray.length > 0) {
                  filteredArray.forEach(topic => {
                    industriesServedArray.push(this.state.industriesServed.find(topics => topics.value === Number(topic)));
                  });
                }
                this.setState({ industriesServedData: industriesServedArray })
              }

              if (this.state.taskDetails.servicesTypeId && this.state.taskDetails.servicesTypeId !== 0 && this.state.taskDetails.servicesTypeId !== "0") {
                var array = (this.state.taskDetails.servicesTypeId !== null || this.state.taskDetails.servicesTypeId !== "") ? this.state.taskDetails.servicesTypeId.split(',') : [];
                let serviceTypeArray = this.state.servicesTypeData;
                const filteredArray = array.filter(value => value !== "0");
                if (filteredArray && filteredArray.length > 0) {
                  filteredArray.forEach(topic => {
                    serviceTypeArray.push(this.state.serviceType.find(topics => topics.value === Number(topic)));
                  });
                }
                this.setState({ servicesTypeData: serviceTypeArray })
              }
              if (this.state.taskDetails.associationBenefitsId && this.state.taskDetails.associationBenefitsId !== 0 && this.state.taskDetails.associationBenefitsId !== "0") {
                var array = (this.state.taskDetails.associationBenefitsId !== null || this.state.taskDetails.associationBenefitsId !== "") ? this.state.taskDetails.associationBenefitsId.split(',') : [];
                let associationBenefitsDataArray = this.state.associationBenefitsData;
                const filteredArray = array.filter(value => value !== "0");
                if (filteredArray && filteredArray.length > 0) {
                  filteredArray.forEach(topic => {
                    associationBenefitsDataArray.push(this.state.associationBenefits.find(topics => topics.value === Number(topic)));
                  });
                }
                this.setState({ associationBenefitsData: associationBenefitsDataArray })
              }
              this.setState({ taskDetails: data });
              this.getMTORegistryDetailsById();
              this.getContactInformationDetailById(data.memberId)
              this.getMTOPricing();
            },
            () => this.setState({ validState: { isValid: true, error: {} } })
          );
          this.setState({ setAddeditModalOpen: true });
        } else {
          this.swalServices.Error(response.message);
        }
      } else {
        this.swalServices.Error(
          "This membership is currently a non-member. Please update membership type before processing application."
        );
      }
      this.setState({ isLoading: false });
    });
  };

  getMTORegistryDetailsById = () => {
    let request = this.state.taskDetails.memberId;
    this.mtoServices.getMTORegistryDetailsById(request).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let mtoRegistryData = response.responseItem.responseContent;
        this.setState(prevState => ({
          taskDetails: {
            ...prevState.taskDetails,
            mtoRegistryId: mtoRegistryData.mtoRegistryId,
            membershipTypeId: mtoRegistryData.membershipTypeId,
            insuranceCompanyName: mtoRegistryData.insuranceCompanyName,
            policyNumber: mtoRegistryData.policyNumber,
            expiryDate: mtoRegistryData.expiryDate,
            insurancePolicyFilePath: mtoRegistryData.insurancePolicyFilePath,
            // approvalDate: mtoRegistryData.approvalDate,
            mtoSubscriptionStartDate: mtoRegistryData.mtoSubscriptionStartDate,
            mtoSubscriptionEndDate: mtoRegistryData.mtoSubscriptionEndDate,
            mtoCertificateNo: mtoRegistryData.mtoCertificateNo,
            mtoCertificateFilePath: mtoRegistryData.mtoCertificateFilePath,
          }
        }));
      }
      else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
    })
  }

  getMTOPricing = () => {
    this.mtoServices.getMTOPricing().then((response) => {
      if (response.statusCode === 200 && response.responseItem.responseContent != null) {
        let details = response.responseItem.responseContent;
        let mtoPricing = this.state.mtoPricing;
        mtoPricing.mtoPricingData = details;

        mtoPricing.ordinaryMtoPricingId = details[0].mtoPricingId
        mtoPricing.qualifyingMtoPricingId = details[1].mtoPricingId

        mtoPricing.ordinaryMtoTier = details[0].mtoTier
        mtoPricing.ordinaryMtoTier = details[1].mtoTier

        mtoPricing.ordinaryMembershipTypeId = details[0].membershipTypeId
        mtoPricing.qualifyingMembershipTypeId = details[1].membershipTypeId

        mtoPricing.ordinarySubscriptionPrice = details[0].subscriptionPrice;
        mtoPricing.qualifyingSubscriptionPrice = details[1].subscriptionPrice;
        this.setState({ mtoPricing: mtoPricing });


        let taskDetails = this.state.taskDetails;
        if (taskDetails.membershipTypeId === 1) {
          let mtoRegistryFee = mtoPricing.ordinarySubscriptionPrice;
          taskDetails.mtoRegistryFee = mtoRegistryFee
        } else {
          let mtoRegistryFee = mtoPricing.qualifyingSubscriptionPrice;
          taskDetails.mtoRegistryFee = mtoRegistryFee
        }
        this.setState({ taskDetails: taskDetails });
      } else {
        this.swalServices.Error(response.message);
      }
    });
  };

  getContactInformationDetailById = (id) => {
    if (id > 0 && id != null) {
      let request = [id]
      this.corporateMemberServices.getContactInformationDetailById(request).then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          let details = response.responseItem.responseContent;
          let taskDetails = this.state.taskDetails;
          taskDetails.contactInformationDetail = details
          this.setState({ taskDetails: taskDetails });

          let ceoDetails = details[0]
          let firstRepresentativeDetails = details[1]
          this.setState({ ceoDetails: ceoDetails, firstRepresentativeDetails: firstRepresentativeDetails })
        }
        else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoading: false });
      })
    }
  }

  setSendClarificationsFlag = () => {
    this.setState({ setSendClarifications: true });
  }

  handleChangeClarificationDetails = (data) => {
    if (typeof data === "string") {
      this.setState({
        clarification: data,
      });
    }
  };

  saveClarificationDetails = () => {
    this.setState({ setSendClarifications: true });
    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_SendClarifications.replace(
          "{0}",
          "Admin"
        ),
        "",
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      ).then((response) => {
        if (response) {
          let firstName = "";
          let lastName = "";
          let emailAddress = "";
          if (this.state.ceoDetails.sameAsFirstFlag === true) {
            firstName = this.state.ceoDetails.firstName
            lastName = this.state.ceoDetails.lastName
            emailAddress = this.state.ceoDetails.emailAddress
          } else {
            firstName = this.state.firstRepresentativeDetails.firstName
            lastName = this.state.firstRepresentativeDetails.lastName
            emailAddress = this.state.firstRepresentativeDetails.emailAddress
          }

          let request = {
            memberId: this.state.taskDetails.memberId,
            clarificationDetails: this.state.clarification,
            taskId: this.state.taskDetails.taskId,
            firstName: firstName,
            lastName: lastName,
            emailAddress: emailAddress,
          };
          this.setState({ isLoadingClarification: true });

          this.mtoServices.mtoTaskListSendClarificationMail(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
              this.setState({ setSendClarifications: false });
              this.setState({ clarification: "" });
              this.setState({ sendEscalation: true }, () =>
                this.setState({ setAddeditModalOpen: false })
              );
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isLoadingClarification: false });
          });
        } else {
          this.setState({ isLoading: false });
          this.setState({ setSendClarifications: false });
        }
      });
  };

  addEditMembershipTaskAndSendPaymentLink = () => {
    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_Payment.replace("{0}", "Payment Link"),
        CommonSuccessMessages.Send_Payment_Link.replace("{0}", "Payment Link"),
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        let resp = response;
        if (resp === true) {
          this.SendPaymentLinkToMember();
        }
      });
  };

  addMembershipPaymentData = () => {
    let request = { ...this.state.taskDetails };
    request.corporateId = this.state.taskDetails.memberId
    request.taskId = this.state.taskDetails.taskId;
    request.finalCalculatedPriceId = this.state.taskDetails.finalCalculatedPriceId;
    request.entranceFee = this.state.taskDetails.entranceFee;
    request.subscriptionFee = this.state.taskDetails.subscriptionFee;
    request.subTotalAmount = this.state.taskDetails.subtotalPrice;
    request.gSTAmount = this.state.taskDetails.gstPrice;
    request.discountedAmount = this.state.taskDetails.discountedPrice;
    request.totalAmount = this.state.taskDetails.totalPrice;
    request.invoicePath = this.state.taskDetails.invoicePath;
    request.paymentVia = this.state.taskDetails.paymentVia;
    request.paymentStatus = this.state.taskDetails.paymentStatus;

    request.paymentsCreditsApplied = this.state.taskDetails.paymentsCreditsApplied;
    request.transactionId = this.state.taskDetails.transactionId;
    request.membershipPaymentTypeId = this.state.taskDetails.membershipPaymentTypeId;
    request.voucherCode = this.state.taskDetails.voucherCode;

    request.gstRate = this.state.taskDetails.gstRate;
    // let found = this.state.paymentsMethods.find(x => x.id == this.state.pricingTable.paymentMethodId);
    // if (found && (request.totalAmount !== 0 && request.totalAmount !== 0.00 && request.totalAmount !== "0" && request.totalAmount != "0.00")) {
    //   request.paymentVia = found.name;
    // }
    // else {
    //   request.paymentVia = '';
    // }

    request.paymentStatus = 'Pending';
    request.membershipTenureId = 1;
    request.createdAt = new Date();
    request.createdBy = this.state.corporateMemberId;
    request.createdAppId = 115;
    request.paymentDescription = "New membership payment";
    request.membersReceiptId = this.state.taskDetails.membersReceiptId;
    request.membersReceiptId = this.state.taskDetails.membersReceiptId;
    request.membershipPaymentInvoicePath = this.state.taskDetails.membershipPaymentInvoicePath ? this.state.taskDetails.membershipPaymentInvoicePath : 'invoicepath';

    // request.membershipPaymentTypeId = (this.state.isRenewal === true) ? 3 : 1;


    this.TaskListServices.addMembershipPaymentData(request).then((response) => {
      if (response.statusCode === 200 && response.responseItem.responseContent != null) {
        let taskDetails = response.responseItem.responseContent;
        this.setState({ taskDetails: taskDetails })
      } else {
        this.swalServices.Error(response.message);
        this.setState({ isProceedPayment: false });
      }
      this.setState({ isLoading: false });
    })
  }

  addEditTask = () => {
    let request = { ...this.state.taskDetails }
    this.TaskListServices.addEditTask(request).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        this.setState({ setAddeditModalOpen: false }, () =>
          this.getAllMTOTasksList()
        );
        this.swalServices.Success("Details Add Successfully..")
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoadingApprove: false });
    });
  }

  // getGSTRate = () => {
  //   this.financeService.getGSTRate().then((response) => {
  //     if (response.statusCode === 200 && response.responseItem != null) {
  //       let data = response.responseItem.responseContent.gstRate
  //         ? response.responseItem.responseContent.gstRate
  //         : 0;
  //       let gstRate = 0;
  //       let gstAmount = 0;
  //       if (data > 0) {
  //         gstRate = data / 100;
  //         gstAmount = 1 + data / 100;
  //       } else {
  //         gstRate = 0;
  //       }

  //       this.setState({
  //         gstRate: gstRate,
  //         gstAmount: gstAmount,
  //         gstPercentage: data,
  //       }, () => {

  //       });
  //     }
  //   });
  // };


  // countAmount = () => {
  //   let taskDetails = { ...this.state.taskDetails };
  //   let gstPercent = this.state.gstPercentage;
  //   let subTotalAmount = taskDetails.mtoRegistryFee;
  //   let countGST = (subTotalAmount * (gstPercent / 100)).toFixed(2);
  //   let countGSTAmount = convertToDecimal(countGST);
  //   let data = { ...this.state.taskDetails };
  //   let t = (subTotalAmount + countGSTAmount).toFixed(2);
  //   let totalAmount = convertToDecimal(t);
  //   data.mtoGSTAmount = countGSTAmount;
  //   data.mtoTotalAmount = totalAmount;
  //   this.setState({ taskDetails: data });
  // };


  SendPaymentLinkToMember = () => {
    // if (this.state.taskDetails.approvalDate === "" || this.state.taskDetails.approvalDate === null) {
    //   this.addEditTask();
    // }
    // else {
    if (this.isValidateAllFields) {
      var pricingList = [];
      var request = { ...this.state.taskDetails, ...pricingList };
      request.taskId = this.state.taskDetails.taskId;
      request.memberId = this.state.taskDetails.memberId;
      request.contactRoleId = this.state.taskDetails.contactRoleId;
      request.IsApprovalRequired = true;
      request.IsPaymentLinkSent = false;
      request.subscriptionStartDate = request.subscriptionStartDate
      request.generalEmailAddress = request.generalEmailAddress
      request.billingCategoryId = request.billingCategoryId ? request.billingCategoryId : 1
      request.statusId = 9
      var currentDate = new Date();
      request.subscriptionEndDate = new Date(currentDate.getFullYear(), 11, 32);
      request.subscriptionEndDate.setHours(0, 0, 0, 0);
      this.setState({ isLoadingApprove: true });

      request.contactInformationDetail = this.state.taskDetails.contactInformationDetail
      request.membershipPaymentInvoicePath = this.state.taskDetails.membershipPaymentInvoicePath;
      request.subscriptionStartDate = this.state.taskDetails.approvalDate;
      this.state.taskDetails.approvalDate ? request.isCouncilApproved = true : request.isCouncilApproved = false;
      request.isAppliedForRenewal = false
      request.mtoRegistryFee = this.state.taskDetails.mtoRegistryFee

      if (this.state.taskDetails.approvalDate === undefined || this.state.taskDetails.approvalDate === "" || this.state.taskDetails.approvalDate === null) {
        let currentDate = new Date();
        request.approvalDate = currentDate;
        // request.subscriptionStartDate = currentDate;
      }
      this.mtoServices.addEditMTOTaskAndSendPaymentLink(request).then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          let id = response.responseItem.responseContent.keyId
          let taskDetails = this.state.taskDetails
          taskDetails.taskId = id
          this.setState({ taskDetails: taskDetails }, () => {
            //this.generatePaymentInvoice();
          })
          this.setState({ setPaymentLink: true }, () =>
            this.setState({ setAddeditModalOpen: false }),
            this.getAllMTOTasksList()
          );
          // this.swalServices.Success("Details Added Successfully!")
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoadingApprove: false });
      });
    }
    // }
  };

  isValidateAllFields = () => {
    const newValidState = isValidForm(
      this.state.taskDetails,
      this.state.validationRule,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  validateField = (key) => {
    const newValidState = validate(
      key,
      this.state.taskDetails,
      this.state.validationRule,
      this.state.validState
    );
    this.setState({ validState: newValidState });
  };

  setPagination = (newPagination) => {
    this.setState({ pagination: newPagination });
    this.getAllMTOTasksList(newPagination);
  };

  setFilterParameters = (id, drpIdentity) => {
    let detail = this.state.taskDetails;
    if (drpIdentity === "MembershipType") {
      detail["membershipTypeId"] = id;
      this.validateField("membershipTypeId");
    }
    if (drpIdentity === "BillingCategories") {
      detail["billingCategoryId"] = id;
      //this.validateField("billingCategoryId");
    }
    if (drpIdentity === "AssociationBenefits") {
      detail["associationBenefitsId"] = id;
      this.validateField("associationBenefitsId");
    }
    this.setState({ taskDetails: detail });
  };

  handleChangeDropdown = (index, fieldName, value) => {
    const { taskDetails } = this.state;
    let updatedContactInfo = [...taskDetails.contactInformationDetail];
    updatedContactInfo[index] = {
      ...updatedContactInfo[index],
      [fieldName]: value
    };

    this.setState({
      taskDetails: {
        ...taskDetails,
        contactInformationDetail: updatedContactInfo
      }
    });
  };

  setFilterParametersForList = (id, drpIdentity) => {
    let detail = this.state.pagination;
    if (drpIdentity === "ApplicationStatus") {
      detail["filterByStatus"] = id;
    }
    this.setState({ pagination: { ...detail } });
    this.getAllMTOTasksList();
  };

  searchByName = (value) => {
    let detail = this.state.pagination;
    detail.searchText = "";
    this.setState({ pagination: { ...detail } });
    if (value.length > 2) {
      detail.pageNo = 1;
      detail.pageSize = 10;
      detail.searchText = value;
      this.setState({ pagination: { ...detail } });
    }
    this.getAllMTOTasksList();
  };

  handleChangeForPagination(event) {
    const value = event.target.value;
    const name = event.target.name;
    let detail = this.state.pagination;
    let fulldate = (detail[name] = value === "" ? null : value);
    let date = new Date(fulldate); //1/1/1753 12:00:00 AM and 12/31/9999 11:59:59 PM
    let startLimit = new Date("1/1/1753 12:00:00 AM");
    let endLimit = new Date("12/31/9999 11:59:59 PM");
    detail[name] = value;
    this.setState({ pagination: { ...detail } }, () => {
      if (startLimit < date && date < endLimit) {
        this.getAllMTOTasksList();
      } else if (fulldate === null) {
        this.getAllMTOTasksList();
      }
    });
  }

  handleChange(event) {
    const value = event.target.value;
    const name = event.target.name;
    let detail = this.state.taskDetails;
    detail[name] = value;

    this.setState({ taskDetails: { ...detail } }, () => {
      if (name === "incorporationDate") {
        let newtenureArr = [];
        if (!isNaN(Date.parse(this.state.taskDetails.incorporationDate))) {
          let sDate = new Date(this.state.taskDetails.incorporationDate);
          let eDate = new Date();
          let yearDifference = eDate.getFullYear() - sDate.getFullYear();

          if (
            this.state.taskDetails.isAppliedForRenewal === true &&
            yearDifference < 5
          ) {
            let eDate = new Date(this.state.taskDetails.subscriptionEndDate);
            let currentDate = new Date();
            let renewYearDiff = eDate.getFullYear() - currentDate.getFullYear();

            for (let i = 1; i <= 5 - yearDifference - renewYearDiff; i++) {
              let tenure = {
                id: i,
                name: `${i} Year`,
              };
              newtenureArr.push(tenure);
            }
            this.setState({ tenureList: newtenureArr }, () =>
              this.getPriceTabelForTaskListProcess()
            );
          } else {
            for (let i = 1; i <= 5 - yearDifference; i++) {
              let tenure = {
                id: i,
                name: `${i} Year`,
              };
              newtenureArr.push(tenure);
            }
            this.setState({ tenureList: newtenureArr }, () =>
              this.getPriceTabelForTaskListProcess()
            );
          }
        } else {
          this.setState({ tenureList: this.state.storeBasetenureList }, () =>
            this.getPriceTabelForTaskListProcess()
          );
        }
      }
    })
  }

  onDropDownChange = (index) => {
    this.setState({ setDropdownOpen: true });
    this.setState({ setDropdownIndex: index });
  };

  selectTask = (value, e) => {
    e.stopPropagation();
    if (value > 0) {
      this.getTaskByCompanyId(value);
    }
  };

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.setState({ setDropdownOpen: false });
    }
  }

  actionClick = (index, value, option, event) => {
    if (option === "Process") {
      var id = this.state.taskList[index].mtoTaskId;
      this.setState(
        { selectedTaskId: this.state.taskList[index].mtoTaskId },
        () => {
          this.selectTask(id, event);
        }
      );
    } else if (option === "Delete") {
      this.deleteTaskListDetailsByTaskId(value);
    }
  };

  deleteTaskListDetailsByTaskId = (companyId) => {
    this.TaskListServices.deleteTaskListDetailsByTaskId(companyId).then(
      (response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          this.swalServices.Success(
            "Membership Task List Entry Deleted Successfully."
          );
          let resetpag = {
            pageNo: 1,
            pageSize: 10,
            orderByColumn: "",
            orderFlag: 0,
            searchText: "",
            status: 0,
            dateFrom: null,
            dateTo: null,
            filterByStatus: 0,
          };
          this.setState({ pagination: resetpag }, () => {
            this.getAllMTOTasksList();
          });
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoading: false });
      }
    );
  };

  actions = (element, index, value) => {
    return element !== "memberId" ? null : (
      <td>
        <ActionContainer>
          <DropdownAction
            key={index}
            value={value}
            id={index}
            index={index}
            options={this.state.actionDropdown}
            align="right"
            onOptionClick={this.actionClick.bind(this)}
          />
        </ActionContainer>
      </td>
    );
  };

  onProcessModalClose = (e) => {
    e.stopPropagation();
    this.setState({ setAddeditModalOpen: false });
  };

  updateCorporateMemberUpdate = (value) => {
    if (value && value > 0) {
      const encryptedValue = encryptAES(value);
      const newUrl = '/CreateCorporateMembers/CorporateMemberId?=' + encryptedValue;
      window.open(newUrl, '_blank');
    }
  }

  handleChangeInDropdown = (selected, drpIdentity) => {
    let page = this.state.pagination;
    if (drpIdentity === "ApplicationStatus") {
      if (selected.value === 0) {
        page.filterByStatus = "";
      } else {
        page.filterByStatus = selected.label;
      }
      this.setState({ pagination: page });
      this.getAllMTOTasksList();
    }
  };

  approveAndUpdateMtoInsuranceRenewal = () => {
    if (this.isValidateAllFields) {
      var request = { ...this.state.taskDetails };
      request.taskId = this.state.taskDetails.taskId;
      request.memberId = this.state.taskDetails.memberId;
      request.isAppliedForRenewal = true
      if (this.state.taskDetails.approvalDate === undefined || this.state.taskDetails.approvalDate === "" || this.state.taskDetails.approvalDate === null) {
        let currentDate = new Date();
        request.approvalDate = currentDate;
      }

      this.setState({ isLoadingApprove: true });
      this.mtoServices.approveAndUpdateMtoInsuranceRenewal(request).then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          let id = response.responseItem.responseContent.keyId
          let taskDetails = this.state.taskDetails
          taskDetails.taskId = id
          this.setState({ taskDetails: taskDetails });
          this.swalServices.Success("MTO Insurance Validation Approved Successfully!")
          this.setState({ setAddeditModalOpen: false })
          this.getAllMTOTasksList()
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoadingApprove: false });
      });
    }
    // }
  };

  render() {
    if (this.state.route != null) {
      return <Navigate to={this.state.route} />;
    }
    return (
      <>
        <div className="main-body-section">
          <div className="bg-white pl-8 pt-10 pb-12">
            <div className="grid grid-cols-12 gap-6 w-full items-center">
              <div className="2xl:col-span-5 lg:col-span-6 col-span-12">
                <h2 className="text-xl theme-color">Date</h2>
                <div className="grid grid-cols-12 gap-6 items-center w-full">
                  <div className=" 2xl:col-span-5 lg:col-span-5 col-span-12 w-full">
                    <input
                      id="default"
                      name="dateFrom"
                      className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                      type="date"
                      value={this.state.pagination.dateFrom}
                      onChange={(e) => this.handleChangeForPagination(e)}
                    />
                  </div>
                  <div className=" 2xl:col-span-1 lg:col-span-2 col-span-12 w-full text-center">
                    <h2 className="text-xl theme-color">To</h2>
                  </div>
                  <div className=" 2xl:col-span-5 lg:col-span-5 col-span-12 w-full">
                    <input
                      id="default"
                      name="dateTo"
                      className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                      type="date"
                      value={this.state.pagination.dateTo}
                      onChange={(e) => this.handleChangeForPagination(e)}
                    />
                  </div>
                </div>
              </div>
              <div className="2xl:col-span-3 lg:col-span-4 col-span-12">
                <h2 className="pl-8 block text-xl font-medium  theme-color">
                  Application Status
                </h2>
                <div className="pl-8 border-l-[1px] border-[#757575]">
                  <Selector
                    options={this.state.statusList}
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    onChange={this.handleChangeInDropdown.bind(this)}
                    allowSelectAll={false}
                    value={this.state.statusList.find(
                      (item) =>
                        item.label === this.state.pagination.filterByStatus
                    )}
                    drpIdentity="ApplicationStatus"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-6 gap-4 pt-10 px-8">
            <h2 className="col-start-1 col-end-3 text-3xl font-bold text-[#757575]">
              {`Total:${this.state.totalResultes}`}
            </h2>
            <div className="col-end-7 col-span-3 grid grid-cols-3 items-center">
              <div className="text-[#757575] text-xl">Search by Company </div>
              {/* <input className="col-span-2 text-lg font-bold  h-[40px] w-full text-[#757575]"/> */}
              <input
                id="default"
                className="col-span-2 text-lg font-bold  h-[55px] w-full text-[#757575] border-white"
                type="text"
                onChange={(e) => this.searchByName(e.target.value)}
              />
            </div>
          </div>
          <main className="pb-10">
            <div className="w-full mx-auto">
              <div className="relative">
                <div>
                  <div className=" mt-6">
                    <Table
                      columns={[
                        { name: "registrationDate", title: "Registration Date" },
                        { name: "GeneralEmailAddress", title: "Email Address" },
                        { name: "OrganisationName", title: "Organisation Name" },
                        { name: "OrganisationUEN", title: "Organisation UEN" },
                        { name: "membershipType", title: "Membership Type" },
                        { name: "mtoTaskStatusId", title: "Application Status" },
                        { name: "memberId", title: "Action" },
                      ]}
                      pagination={this.state.pagination}
                      rows={this.state.taskList}
                      sortingColumns={[""]}
                      isLoading={this.state.isLoading}
                      totalResultes={this.state.totalResultes}
                      totalCount={this.state.totalResultes}
                      setPagination={this.setPagination.bind(this)}
                      customScope={[
                        {
                          column: "memberId",
                          renderTableData: this.actions.bind(this),
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
        <div className="member-task-process">
          <MTOTaskListProcess
            setAddeditModalOpen={this.state.setAddeditModalOpen}
            membershipType={this.state.membershipType}
            membershipRevenue={this.state.membershipRevenue}
            countries={this.state.countries}
            serviceType={this.state.serviceType}
            industriesServed={this.state.industriesServed}
            getToKnow={this.state.getToKnow}
            associationBenefits={this.state.associationBenefits}
            mrMrs={this.state.mrMrs}
            designation={this.state.designation}
            years={this.state.years}
            emailCirculars={this.state.emailCirculars}
            billingCategories={this.state.billingCategories}
            numberOfChapters={this.state.numberOfChapters}
            taskDetails={this.state.taskDetails}
            basePriceTable={this.state.basePriceTable}
            allowableDiscountTable={this.state.allowableDiscountTable}
            percentageDiscountTable={this.state.percentageDiscountTable}
            systemCalculatedTable={this.state.systemCalculatedTable}
            disablePaymentButton={this.state.disablePaymentButton}
            disableSubscription={this.state.disableSubscription}
            validState={this.state.validState}
            setModalOpen={() => this.setState({ setAddeditModalOpen: false })}
            onClose={(e) => { e.stopPropagation(); this.setState({ setAddeditModalOpen: false }); }}
            validateField={this.validateField.bind(this)}
            setFilterParameters={this.setFilterParameters.bind(this)}
            addEditMembershipTaskAndSendPaymentLink={this.addEditMembershipTaskAndSendPaymentLink.bind(this)}
            approveAndUpdateMtoInsuranceRenewal={this.approveAndUpdateMtoInsuranceRenewal.bind(this)}
            setSendClarificationsFlag={this.setSendClarificationsFlag.bind(this)}
            closeModalOnBack={() => { this.setState({ setAddeditModalOpen: false }); }}
            isLoading={this.state.isLoading}
            isLoadingApprove={this.state.isLoadingApprove}
            isLoadingClarification={this.state.isLoadingClarification}
            isLoadingReject={this.state.isLoadingReject}
            handleChangeMultiDropdown={this.handleChangeMultiDropdown.bind(this)}
            handleChange={this.handleChange.bind(this)}
            servicesTypeData={this.state.servicesTypeData}
            associationBenefitsData={this.state.associationBenefitsData}
            industriesServedData={this.state.industriesServedData}
            rejectApplicationForMember={this.rejectApplicationForMember.bind(this)}
            isLoadingSendMail1={this.state.isLoadingSendMail1}
            isLoadingSendMail2={this.state.isLoadingSendMail2}
            updateCorporateMemberUpdate={this.updateCorporateMemberUpdate.bind(this)}
            getInvoiceReceiptPdfByBookingId={this.getInvoiceReceiptPdfByBookingId.bind(this)}
            mtoPricing={this.state.mtoPricing}
            transactionTypes={this.state.transactionTypes}
          />
        </div>
        <div className="send-clarification-model">
          <SendClarifications
            clarificationModal={this.state.setSendClarifications}
            clarification={this.state.clarification}
            setOpenModal={() => this.setState({ setSendClarifications: false })}
            onTinyEceEditorChange={(data) =>
              this.handleChangeClarificationDetails(data)
            }
            // onClose={(e) => {e.stopPropagation();
            //   this.setState({ setSendClarifications: false });
            // }}
            // getClarificationDetails={this.getClarificationDetails.bind(this)}
            saveClarificationDetails={this.saveClarificationDetails.bind(
              this
            )}
          />
        </div>

        <div className="membership-task-list-process-sec">
          <SendPaymentLink
            organisationName={this.state.taskDetails.organisationName}
            generalEmailAddress={this.state.taskDetails.generalEmailAddress}
            paymentLinkModal={this.state.setPaymentLink}
            setOpenModal={() => this.setState({ setPaymentLink: false })}
            onClose={(e) => {
              e.stopPropagation();
              this.setState({ setPaymentLink: false });
            }}
          />
        </div>


        {/* <div className="membership-task-list-process-sec">
          <SendForApprove
            organisationName={this.state.taskDetails.organisationName}
            generalEmailAddress={this.state.taskDetails.generalEmailAddress}
            setSendApproveModal={this.state.setSendApprove}
            setOpenModal={() => this.setState({ setSendApprove: false })}
            onClose={(e) => {
              e.stopPropagation();
              this.setState({ setSendApprove: false });
            }}
          />
          
          <SendPaymentLink
            organisationName={this.state.taskDetails.organisationName}
            generalEmailAddress={this.state.taskDetails.generalEmailAddress}
            paymentLinkModal={this.state.setPaymentLink}
            setOpenModal={() => this.setState({ setPaymentLink: false })}
            onClose={(e) => {
              e.stopPropagation();
              this.setState({ setPaymentLink: false });
            }}
          />
          <SendQuotation
            organisationUEN={this.state.taskDetails.organisationName}
            generalEmailAddress={this.state.taskDetails.generalEmailAddress}
            setSendQuotationModal={this.state.sendReject}
            setOpenModal={() => this.setState({ sendReject: false })}
            onClose={(e) => {
              e.stopPropagation();
              this.setState({ sendReject: false });
            }}
          />
          <SendInvoice
            organisationName={this.state.taskDetails.organisationName}
            generalEmailAddress={this.state.taskDetails.generalEmailAddress}
            setSendInvoiceModal={this.state.sendInvoice}
            setOpenModal={() => this.setState({ sendInvoice: false })}
            onClose={(e) => {
              e.stopPropagation();
              this.setState({ sendInvoice: false });
            }}
          />
          <EscalateModal
            organisationName={this.state.taskDetails.organisationName}
            generalEmailAddress={this.state.taskDetails.generalEmailAddress}
            setSendInvoiceModal={this.state.sendEscalation}
            setOpenModal={() => this.setState({ sendEscalation: false })}
            onClose={(e) => {
              e.stopPropagation();
              this.setState({ sendEscalation: false });
              window.location.reload();
            }}
          />
        </div> */}
      </>
    );
  }
}
